export default __webpack_public_path__ + "static/media/back.610db75c.svg";